import dayjs from 'dayjs';

/**
 * 시작일부터 연속 dayCount일 구간의 시작/종료일(YYYYMMDD)을 반환한다.
 * end = start + (dayCount - 1)일
 */
export const getForwardDateRange = (startDate: string, dayCount = 7): { start: string; end: string } => {
  const start = dayjs(startDate.replaceAll('-', '')).format('YYYYMMDD');
  const end = dayjs(start)
    .add(dayCount - 1, 'day')
    .format('YYYYMMDD');
  return { start, end };
};
